<template>
  <footer class="main-footer-four" style="background-color: #000000;">
    <div class="main-footer-four__top">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-4">
            <div class="footer-widget footer-widget--about">
              <a href="/" class="footer-widget__logo">
                <img src="@/assets/images/logowhite.png" width="300" alt="Logo Karoons">
              </a>
            </div>
          </div>
          <div class="col-md-12 col-lg-8">
            <div class="footer-widget__department-columns">
              <div v-for="(departmentGroup, index) in departmentColumns" :key="index"
                class="footer-widget__department-column">
                <ul class="footer-widget__links">
                  <li v-for="department in departmentGroup" :key="department.id" class="footer-link-item">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3"
                      stroke="red" class="footer-icon">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M5.25 4.5l7.5 7.5-7.5 7.5m6-15l7.5 7.5-7.5 7.5" />
                    </svg>
                    <a @click.prevent="navigateToDepartment(department.slug)" class="footer-link">
                      {{ department.name }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-footer-four__bottom" style="background-color: #000000;">
      <div class="container">
        <div class="main-footer-four__bottom__inner">
          <p class="main-footer-four__copyright">
            &copy; {{ t('footer.copyright') }}
            <span class="dynamic-year">{{ new Date().getFullYear() }}</span>
            <img src="@/assets/images/Grupo-KArout.png" width="90" alt="Grupo Karout" class="gk" />
          </p>
          <p class="developed-by">
            Desenvolvido por:
            <img src="@/assets/images/CodeCraft.png" alt="CodeCraft" class="codecraft-logo" />
          </p>

        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { fetchCategories } from '@/services/apiService';
import { useI18n } from 'vue-i18n';

export default {
  name: 'FooterView',
  setup() {
    const { t } = useI18n();
    return { t };
  },
  data() {
    return {
      departments: []
    };
  },
  computed: {
    departmentColumns() {
      const columns = [];
      for (let i = 0; i < this.departments.length; i += 3) {
        columns.push(this.departments.slice(i, i + 3));
      }
      return columns;
    }
  },
  created() {
    this.fetchDepartments();
  },
  methods: {
    async fetchDepartments() {
      try {
        const categories = await fetchCategories();
        this.departments = categories[0]?.departments || [];
      } catch (error) {
        console.error('Erro ao buscar departamentos:', error);
      }
    },
    navigateToDepartment(departmentSlug) {
      const categoriaSlug = 'pneus';
      const currentPage = 1;

      if (this.$route.name === 'produtos') {
        this.$router.replace({
          name: 'produtos',
          params: {
            categoriaSlug,
            departamentoSlug: departmentSlug
          },
          query: { page: currentPage }
        });
      } else {
        this.$router.push({
          name: 'produtos',
          params: {
            categoriaSlug,
            departamentoSlug: departmentSlug
          },
          query: { page: currentPage }
        });
      }
    }
  }
};
</script>



<style scoped>
.footer-widget__department-columns {
  display: flex;
  justify-content: space-between;
}

.footer-widget__department-column {
  flex: 1;
}

.footer-widget__links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-link-item {
  margin-bottom: 8px;
}

.footer-link {
  color: #ffffff;
  text-decoration: none;
  font-size: 18px;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #f4c842;
}

footer .footer-widget__department-columns svg {
  color: red;
  width: 12px;
  height: 12px;
  margin-right: 8px;
}
.footer-bottom-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.footer-developed-by {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ffffff;
  font-size: 14px;
}

.codecraft-logo {
  width: 100px;
  height: auto;
}
.main-footer-four__copyright {
  color: #cccccc;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap; /* Mantém em uma linha */
  gap: 8px;
  font-size: 14px;
  text-align: center;
  flex-shrink: 1;
  overflow: hidden;
  white-space: nowrap;
}

.developed-by {
  color: #999999;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 11px;
  margin-top: 8px;
  text-align: right;
}



.gk {
  height: auto;
  margin-left: 6px;
}

.codecraft-logo {
  width: 75px;
  height: auto;
  margin-left: 4px;
}

.footer-divider {
  margin: 0 8px;
  color: #ffffff;
}
@media (max-width: 768px) {
  .main-footer-four__copyright {
    font-size: 12px;
    gap: 6px;
  }

  .gk {
    width: 70px;
    margin-left: 4px;
  }

  .codecraft-logo {
    width: 70px;
    margin-left: 4px;
  }
  
  .developed-by {
    font-size: 11px;
  }

  .footer-divider {
    margin: 0 6px;
  }
}

@media (max-width: 480px) {
  .main-footer-four__copyright {
    font-size: 10px;
    gap: 4px;
  }

  .gk {
    width: 60px;
  }

  .codecraft-logo {
    width: 60px;
  }
  
  .developed-by {
    font-size: 9px;
  }

  .footer-divider {
    margin: 0 4px;
  }
}

</style>
